import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import redux from '../../store'
import { actions as authActions } from '../../containers/Auth/store'
import { 
  Menu, Dropdown, Icon, Modal 
} from 'antd'
import { ROLE } from '../../constants/role'
import packageJSON from '../../../package.json'

const confirm = Modal.confirm
const { version } = packageJSON

const confirmLogout = () => {
  confirm({
    title: 'ออกจากระบบ',
    content: 'คุณต้องการจะออกจากระบบหรือไม่?',
    okText: 'ออกจากระบบ',
    okType: 'danger',
    cancelText: 'ยกเลิก',
    onOk() {
      redux.store.dispatch(authActions.logout())
    },
    onCancel() {
    },
  })
}

const menu = (
  <Menu>
    { process.env.REACT_APP_OVERRIDE_LOGIN_METHOD !== 'legacy' ? (
      <Menu.Item key="0">
        <Link to={"/profile"}>
          <Icon type="edit" /> ข้อมูลส่วนตัว
        </Link>
      </Menu.Item>
    ) : null }
    { process.env.REACT_APP_OVERRIDE_LOGIN_METHOD !== 'legacy' ? <Menu.Divider /> : null }
    <Menu.Item key="3">
      <div style={{textAlign: 'left'}}>
        เวอร์ชั่นปัจจุบัน
        <div style={{display: 'inline-block', float: 'right'}}>
          {version}
        </div>
      </div>
    </Menu.Item>
    <Menu.Item key="4">
      <Link to="#" onClick={confirmLogout}>
        <Icon type="lock" /> ออกจากระบบ
      </Link>
    </Menu.Item>
  </Menu>
)

class ProfileMenu extends React.Component {
  roleName(role) {
    if(role) {
      if(ROLE[role]) {
        return `[${ROLE[role]}]`
      }
    }
    return ''
  }

  render() {
    const { profile } = this.props
    return (
      <div className="navigationMenu">
        <Dropdown overlay={menu} placement="bottomRight">
          <a className="ant-dropdown-link">
            { profile && (profile.name || profile.username || 'กำลังโหลด') } <span className="role">{ this.roleName(profile.role) }</span> <Icon type="down" />
          </a>
        </Dropdown>
      </div>
    )
  }
}

export default connect(
  state => ({
    profile: state.auth.loginUser
  })
)(ProfileMenu)




// WEBPACK FOOTER //
// ./src/components/Navigation/profile.js